export default __webpack_public_path__ + "static/media/en-hero-mobile.376a40f1.mp4";